import { render, staticRenderFns } from "./AccountData.vue?vue&type=template&id=594dec9c&"
import script from "./AccountData.vue?vue&type=script&lang=js&"
export * from "./AccountData.vue?vue&type=script&lang=js&"
import style0 from "./AccountData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports